/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_No_MessageInputs */



/**
* | output |
* | --- |
* | "No Message" |
*
* @param {Snapshot_History_No_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_no_message = /** @type {((inputs?: Snapshot_History_No_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_No_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun message")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Nachricht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun messaggio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нет сообщения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin mensaje")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无消息")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メッセージなし")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई संदेश नहीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhuma mensagem")
	return /** @type {LocalizedString} */ ("No Message")
});